export enum ColumnStatusName {
  ASSIGNED = 'Asignado',
  ATTENDING = 'En Atención',
  QUOTED = 'Cotizado',
  PROGRAMMED = 'En Programación',
  PAID = 'Pagado',
  OUT_FOR_DELIVERY = 'En despacho',
  POST_ATTENTION = 'Post Venta',
}

export enum LeadStatusName {
  ASSIGNED = 'assigned',
  PROCESSING = 'processing',
  QUOTED = 'quoted',
  SCHEDULED = 'scheduled',
  PAID = 'paid',
  OUT_FOR_DELIVERY = 'outForDelivery',
  AFTER_SALE = 'afterSale',
}

export enum LeadStatusNameDashboard {
  ASSIGNED = 'assigned',
  PROCESSING = 'processing',
  QUOTED = 'quoted',
  SCHEDULED = 'scheduled',
  PAID = 'paid',
  OUT_FOR_DELIVERY = 'out-for-delivery',
  AFTER_SALE = 'after-Sale',
}

export const LEAD_COLORS: Record<LeadStatusNameDashboard, string> = {
  [LeadStatusNameDashboard.ASSIGNED]: '#078196',
  [LeadStatusNameDashboard.PROCESSING]: '#2855E4',
  [LeadStatusNameDashboard.QUOTED]: '#078196',
  [LeadStatusNameDashboard.SCHEDULED]: '#FFE592',
  [LeadStatusNameDashboard.PAID]: '#82CA48',
  [LeadStatusNameDashboard.OUT_FOR_DELIVERY]: '#A9BCD9',
  [LeadStatusNameDashboard.AFTER_SALE]: '#11A77E',
};

export const LEAD_LABELS: Record<LeadStatusNameDashboard, string> = {
  [LeadStatusNameDashboard.ASSIGNED]: 'Asignado',
  [LeadStatusNameDashboard.PROCESSING]: 'En Atención',
  [LeadStatusNameDashboard.QUOTED]: 'Cotizado',
  [LeadStatusNameDashboard.SCHEDULED]: 'En Programación',
  [LeadStatusNameDashboard.PAID]: 'Pagado',
  [LeadStatusNameDashboard.OUT_FOR_DELIVERY]: 'En despacho',
  [LeadStatusNameDashboard.AFTER_SALE]: 'Post Venta',
};

export enum SubstagesName {
  ASSIGNED = 'S',
  ATTENDING = 'S/A',
  QUOTED = 'S/C',
  PROGRAMMED = 'S/PR',
  PAID = 'S/P',
  OUT_FOR_DELIVERY = 'S/D',
  POST_ATTENTION = 'S/PV',
}

export enum LeadStatusNameFunnel {
  ASSIGNED = 'assigned',
  PROCESSING = 'processing',
  QUOTED = 'quoted',
  SCHEDULED = 'scheduled',
  PAID = 'paid',
  OUT_FOR_DELIVERY = 'out-for-delivery',
  AFTER_SALE = 'after-Sale',
  UNASSIGNED = 'unassigned',
  UNATTENDING = 'unprocessing',
  UNQUOTED = 'unquoted',
  UNPROGRAMMED = 'unscheduled',
  UNPAID = 'unpaid',
  NO_OUT_FOR_DELIVERY = 'no-out-for-delivery',
  NO_AFTER_SALE = 'no-after-sale',
  ARCHIVED = 'archived',
}

export const LEAD_LABELS_FUNNEL: Record<LeadStatusNameFunnel, string> = {
  [LeadStatusNameFunnel.ASSIGNED]: 'Asignado',
  [LeadStatusNameFunnel.PROCESSING]: 'En Atención',
  [LeadStatusNameFunnel.QUOTED]: 'Cotizado',
  [LeadStatusNameFunnel.SCHEDULED]: 'En Programación',
  [LeadStatusNameFunnel.PAID]: 'Pagado',
  [LeadStatusNameFunnel.OUT_FOR_DELIVERY]: 'En despacho',
  [LeadStatusNameFunnel.AFTER_SALE]: 'Post Venta',
  [LeadStatusNameFunnel.ARCHIVED]: 'Archivados',
  [LeadStatusNameFunnel.UNASSIGNED]: 'S',
  [LeadStatusNameFunnel.UNATTENDING]: 'S/A',
  [LeadStatusNameFunnel.UNQUOTED]: 'S/C',
  [LeadStatusNameFunnel.UNPROGRAMMED]: 'S/PR',
  [LeadStatusNameFunnel.UNPAID]: 'S/P',
  [LeadStatusNameFunnel.NO_OUT_FOR_DELIVERY]: 'S/D',
  [LeadStatusNameFunnel.NO_AFTER_SALE]: 'S/PV',
};

export const SUBSTAGES_FUNNEL = [
  'S',
  'S/A',
  'S/C',
  'S/PR',
  'S/P',
  'S/D',
  'S/PV',
];
